const humanAge = {
  adult: 20,
  max: 100,
}

module.exports = humanAge
